// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: `https://exemptionregistry-api-uat.tdlwd.tn.gov/api/1/`,
  //apiUrl: `https://localhost:7189/1/`,
  pageSize: 15, // Default Page Size for tables
  recaptcha: {
    siteKey: '6LejXhMUAAAAADYw9xZ7a9tBb8hNzYmpvxGUAyHA',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
 //import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
 